export const cookieName = 'auth.redirect'
